import { Link } from "@tanstack/react-router";
import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export function PublicFooter() {
  const { t } = useI18n();

  return (
    <footer className="mt-24 border-t border-border bg-primary text-primary-foreground">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-4 md:px-6">
        <div>
          <div className="flex items-center gap-2">
            <span className="grid h-9 w-9 place-items-center rounded-md bg-accent text-accent-foreground font-serif text-lg font-bold">
              D
            </span>
            <div className="leading-tight">
              <div className="text-sm font-semibold">Dahiana Marín</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-primary-foreground/70">
                {t("brand.tagline")}
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm text-primary-foreground/80">{t("footer.about")}</p>
        </div>

        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wider text-accent">
            {t("footer.properties")}
          </h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/$operation/$type" params={{ operation: "venta", type: "casas" }} className="hover:underline">{t("footer.casasVenta")}</Link></li>
            <li><Link to="/$operation/$type" params={{ operation: "venta", type: "departamentos" }} className="hover:underline">{t("footer.deptosVenta")}</Link></li>
            <li><Link to="/$operation/$type" params={{ operation: "alquiler", type: "departamentos" }} className="hover:underline">{t("footer.deptosAlquiler")}</Link></li>
            <li><Link to="/$operation/$type" params={{ operation: "venta", type: "terrenos" }} className="hover:underline">{t("footer.terrenos")}</Link></li>

          </ul>
        </div>

        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wider text-accent">{t("footer.company")}</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/agente" className="hover:underline">{t("footer.about.link")}</Link></li>
            <li><Link to="/vende-tu-propiedad" className="hover:underline">{t("nav.sell")}</Link></li>
            <li><Link to="/blog" className="hover:underline">{t("nav.blog")}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wider text-accent">{t("footer.contact")}</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-accent" />
              <a href="https://wa.me/595986733480" target="_blank" rel="noopener noreferrer nofollow" className="hover:underline">
                +595 986 733 480
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-accent" />
              <a href="mailto:ventas@dahianamarin.com" className="hover:underline">
                ventas@dahianamarin.com
              </a>
            </li>
            <li className="flex items-center gap-3 pt-2">
              <a href="https://instagram.com/dahianamarin.realestate" target="_blank" rel="noopener noreferrer nofollow" aria-label="Instagram" className="hover:text-accent"><Instagram className="h-5 w-5" /></a>
              <a href="https://www.facebook.com/profile.php?id=61583378824766" target="_blank" rel="noopener noreferrer nofollow" aria-label="Facebook" className="hover:text-accent"><Facebook className="h-5 w-5" /></a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-primary-foreground/70 md:flex-row md:px-6">
          <p>© {new Date().getFullYear()} Dahiana Marín Bienes Raíces. {t("footer.rights")}</p>
          <p>{t("footer.city")}</p>
        </div>
      </div>
    </footer>
  );
}
